import { html, TemplateResult } from 'lit'
import type { ProductSpecificationItem } from 'components/discovery/pdp/product-specifications/typing/product-specifications.js'


const formatValue = (item: ProductSpecificationItem): string =>
  item.uom ? `${item.value} ${item.uom}` : item.value

export function renderImagesLayout(items: ProductSpecificationItem[]): TemplateResult {
  return html`
    <cse-group class="image-group">
      ${items.filter((item) => item.picture).map((item) => html`
        <cse-group class="image-item" direction="column" alignment="center">
          <cse-image
            source="${item.picture}"
            alt="${item.value}"
          ></cse-image>
          <cse-text variant="heading-6" >${formatValue(item)}</cse-text>
        </cse-group>
      `)}
    </cse-group>
  `
}
